import Header from "./Header";
import Story from "./Story";
import Entertainment from "./Entertainment";
import FoodAndDrinks from "./Food-Drinks";
import Reviews from "./Reviews";

const Home = () => {
    return ( 
        <main>
            <Header />
            <Story />
            <Entertainment />
            <FoodAndDrinks />
            <Reviews />
        </main>
     );
}
 
export default Home;